import styled from 'styled-components';

interface ChatMessageStylesProps {
  variant: 'sent' | 'received';
}

export const ChatMessageStyles = styled.div<ChatMessageStylesProps>`
  padding: 12px 16px;
  width: max-content;
  max-width: 90%;
  border-radius: 18px 18px 18px 0px;

  ${({ variant }) =>
    variant === 'sent'
      ? `
        margin-left: auto;
        border-radius: 18px 18px 0px 18px;
        background: rgba(128, 62, 255, 1);
      `
      : `
        margin-right: auto;
        background: #14111ECC;
      `}
`;
